__turbopack_context__.v({
  "Actions": "lFXIfG_Actions",
  "CancelButton": "lFXIfG_CancelButton",
  "Message": "lFXIfG_Message",
  "Modal": "lFXIfG_Modal",
  "Overlay": "lFXIfG_Overlay",
  "ResetButton": "lFXIfG_ResetButton",
  "Title": "lFXIfG_Title",
  "skeleton-loading": "lFXIfG_skeleton-loading",
});
